
// Import vendor modules.
import { Controller } from "@hotwired/stimulus";
import * as Turbo from "@hotwired/turbo";

// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //

var CACHED_URLS = Object.create( null );

export class SitePhotosController extends Controller {

	static targets = [ "nextLink", "prevLink" ];

	// ---
	// PUBLIC METHODS.
	// ---

	/**
	* I preload the links and images associated with the Prev/Next anchors.
	*/
	preloadPhotos() {

		this.preloadLink( this.nextLinkTarget );
		this.preloadLink( this.prevLinkTarget );

		// Always mark the current URL has being cached.
		CACHED_URLS[ window.location.href ] = true;

	}

	// ---
	// PRIVATE METHODS.
	// ---

	/**
	* I preload the given Prev/Next link and the associated image.
	*/
	preloadLink( linkTarget ) {

		if ( CACHED_URLS[ linkTarget.href ] ) {

			return;

		}

		CACHED_URLS[ linkTarget.href ] = true;

		new Image().src = linkTarget.dataset.imageSrc;
		// CAUTION: The "preloader" is an UNDOCUMENTED PROPERTY of the session (at least
		// as far as I can tell) - I only found it by looking at the source code for the
		// Turbo project. As such, use this technique at your own risk!
		Turbo.session.preloader.preloadURL( linkTarget );

	}

}
